export default "__VITE_ASSET__12zztgFT__"